import { CollectionProgress as SharedCollectionProgress } from "@/components/dashboard";

type FmbCollectionProgressProps = {
  stats: {
    paymentsReceived?: number;
    paymentsPending?: number;
    vendorPaymentVoucherTotal?: number;
  };
  collectionPercentage: number;
};

export default function FmbCollectionProgress({
  stats,
  collectionPercentage,
}: FmbCollectionProgressProps) {
  const receipts = stats.paymentsReceived || 0;
  const vendorOut = stats.vendorPaymentVoucherTotal || 0;
  const netAfterVendor = receipts - vendorOut;

  return (
    <SharedCollectionProgress
      title="Receipts vs period commitments"
      rateLabel="Share of annual + contribution commitments collected (by receipts)"
      collectionPercentage={collectionPercentage}
      clampPercentage
      amounts={[
        {
          label: "Income — receipts (period)",
          amount: receipts,
          color: "success.main",
        },
        {
          label: "Pending (period)",
          amount: stats.paymentsPending || 0,
          color: "error.main",
        },
        {
          label: "Vendor expenses (period)",
          amount: vendorOut,
          color: "secondary.main",
        },
        {
          label: "Net after vendor payouts",
          amount: netAfterVendor,
          color: netAfterVendor >= 0 ? "success.main" : "error.main",
        },
      ]}
    />
  );
}
